import {
	BigNum,
	VelocityClient,
	MarketType,
	SPOT_MARKET_BALANCE_PRECISION,
} from '@velocity-exchange/sdk';
import { getBorrowAprForMarket } from '@velocity-exchange/common';

export function getCloseBorrowAmountWithBuffer(
	velocityClient: VelocityClient,
	spotMarketIndex: number,
	borrowAmount: BigNum
): BigNum {
	if (!velocityClient || !velocityClient.isSubscribed) return BigNum.zero();

	const borrowApr = getBorrowAprForMarket(
		spotMarketIndex,
		MarketType.SPOT,
		velocityClient
	);

	const simpleBorrowInterest = borrowApr / 100 / 365 / 24 / 60;

	const newWeight = 1 + simpleBorrowInterest;

	const bufferedSwapToAmount = borrowAmount
		.abs()
		.mul(BigNum.from(newWeight * SPOT_MARKET_BALANCE_PRECISION.toNumber()))
		.div(SPOT_MARKET_BALANCE_PRECISION);

	return bufferedSwapToAmount;
}

export const getApyFromApr = (
	aprPercent: number,
	compoundingFrequency: 'hourly' | 'daily'
): number => {
	const n = compoundingFrequency === 'hourly' ? 24 * 365 : 365;
	const aprDecimal = aprPercent / 100;
	return ((1 + aprDecimal / n) ** n - 1) * 100;
};
